/**
 * Parser iterativo: percorre as linhas e extrai pares chave:valor.
 * Lista de bairros RJ e validação de nome (simpleId) — usados em pedidos colados do WhatsApp.
 */

export const BAIRROS_RJ = [
  'Abolição', 'Acari', 'Água Santa', 'Alto da Boa Vista', 'Anchieta', 'Andaraí', 'Anil', 'Bancários', 'Bangu', 'Barra da Tijuca',
  'Barra de Guaratiba', 'Barra Olímpica', 'Barros Filho', 'Benfica', 'Bento Ribeiro', 'Bonsucesso', 'Botafogo', 'Brás de Pina', 'Cachambi', 'Cacuia',
  'Caju', 'Camorim', 'Campinho', 'Campo dos Afonsos', 'Campo Grande', 'Cascadura', 'Catete', 'Catumbi', 'Cavalcanti', 'Centro',
  'Cidade de Deus', 'Cidade Nova', 'Cidade Universitária', 'Cocotá', 'Coelho Neto', 'Colégio', 'Complexo do Alemão', 'Copacabana', 'Cordovil', 'Cosme Velho',
  'Cosmos', 'Costa Barros', 'Curicica', 'Del Castilho', 'Deodoro', 'Encantado', 'Engenheiro Leal', 'Engenho da Rainha', 'Engenho de Dentro', 'Engenho Novo',
  'Estácio', 'Flamengo', 'Freguesia (Ilha)', 'Freguesia (Jacarepaguá)', 'Galeão', 'Gamboa', 'Gardênia Azul', 'Gávea', 'Gericinó', 'Glória',
  'Grajaú', 'Grumari', 'Guadalupe', 'Guaratiba', 'Higienópolis', 'Honório Gurgel', 'Humaitá', 'Ilha de Guaratiba', 'Imperial de São Cristóvão', 'Inhaúma',
  'Inhoaíba', 'Ipanema', 'Irajá', 'Itanhangá', 'Jabour', 'Jacaré', 'Jacarepaguá', 'Jacarezinho', 'Jardim América', 'Jardim Botânico',
  'Jardim Carioca', 'Jardim Guanabara', 'Jardim Sulacap', 'Joá', 'Lagoa', 'Lapa', 'Laranjeiras', 'Leblon', 'Leme', 'Lins de Vasconcelos',
  'Madureira', 'Magalhães Bastos', 'Manguinhos', 'Maracanã', 'Maré', 'Marechal Hermes', 'Maria da Graça', 'Méier', 'Moneró', 'Olaria',
  'Oswaldo Cruz', 'Paciência', 'Padre Miguel', 'Paquetá', 'Parada de Lucas', 'Parque Anchieta', 'Parque Columbia', 'Pavuna', 'Pechincha', 'Pedra de Guaratiba',
  'Penha', 'Penha Circular', 'Piedade', 'Pilares', 'Pitangueiras', 'Portuguesa', 'Praça da Bandeira', 'Praça Seca', 'Praia da Bandeira', 'Quintino Bocaiuva',
  'Ramos', 'Realengo', 'Recreio dos Bandeirantes', 'Riachuelo', 'Ribeira', 'Ricardo de Albuquerque', 'Rio Comprido', 'Rocha', 'Rocha Miranda', 'Rocinha',
  'Sampaio', 'Santa Cruz', 'Santa Teresa', 'Santíssimo', 'Santo Cristo', 'São Conrado', 'São Francisco Xavier', 'Saúde', 'Senador Camará', 'Senador Vasconcelos',
  'Sepetiba', 'Tanque', 'Taquara', 'Tauá', 'Tijuca', 'Todos os Santos', 'Tomás Coelho', 'Turiaçu', 'Urca', 'Vargem Grande',
  'Vargem Pequena', 'Vasco da Gama', 'Vaz Lobo', 'Vicente de Carvalho', 'Vidigal', 'Vigário Geral', 'Vila da Penha', 'Vila Isabel', 'Vila Kennedy', 'Vila Kosmos',
  'Vila Militar', 'Vila Valqueire', 'Vista Alegre', 'Zumbi'
];

function stripDiacritics(str) {
  return String(str)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** Normaliza texto colado (WhatsApp/macOS): NFC, quebras Unicode e colons “tipográficos”. */
function normalizePasteText(text) {
  return String(text || '')
    .normalize('NFC')
    .replace(/[\u2028\u2029\r]/g, '\n')
    .replace(/\uFF1A/g, ':');
}

const FIELD_KEY_RE = /^\s*([A-ZÀ-ÖØ-Þà-öø-ÿÇç\s]+)\s*:\s*(.*)$/i;
const FIELD_KEY_LINE_RE = /^\s*[A-ZÀ-ÖØ-Þà-öø-ÿÇç\s]+\s*:/i;

function getRawField(raw, ...candidates) {
  for (const candidate of candidates) {
    if (raw[candidate]) return raw[candidate];
  }
  const norm = (s) => s.normalize('NFC').toUpperCase().replace(/\s+/g, '_');
  for (const key of Object.keys(raw)) {
    if (candidates.some((candidate) => norm(key) === norm(candidate))) {
      return raw[key];
    }
  }
  return '';
}

export function normalizeNomeForSimpleId(nome) {
  return stripDiacritics(String(nome || '').trim())
    .replace(/[\u00A0\u2000-\u200B\uFEFF]/g, ' ')
    .replace(/\s+/g, ' ');
}

export function isClienteNomeValidForSimpleId(nome) {
  const nomeNorm = normalizeNomeForSimpleId(nome);
  const arrayName = nomeNorm.split(' ');
  if (!arrayName[0]) return false;
  const first = arrayName[0];
  const second = arrayName[1];
  if (second) {
    if (first.length < 2 || second.length < 1) return false;
  } else if (first.length < 3) {
    return false;
  }
  const initialsCodeId = `${first.slice(0, 2)}${second ? second.slice(0, 1) : first.slice(2, 3)}`;
  const upper = initialsCodeId.toUpperCase();
  return upper.length === 3 && /^[A-Z]{3}$/.test(upper);
}

/**
 * Cruza bairro com BAIRROS_RJ: chave BAIRRO, trecho do parse de endereço ou nome do bairro no texto completo do ENDEREÇO (mais longo primeiro).
 */
function matchBairroRjFromEndereco(enderecoRaw, neighborhoodPiece, rawBairroKey, bairros = BAIRROS_RJ) {
  if (rawBairroKey) {
    const found = bairros.find((b) => b.localeCompare(rawBairroKey.trim(), 'pt-BR', { sensitivity: 'accent' }) === 0);
    if (found) return found;
  }
  if (neighborhoodPiece) {
    const found = bairros.find((b) => b.localeCompare(neighborhoodPiece.trim(), 'pt-BR', { sensitivity: 'accent' }) === 0);
    if (found) return found;
  }
  const haystack = `${enderecoRaw || ''} ${neighborhoodPiece || ''}`.trim();
  if (!haystack) return '';
  const normH = stripDiacritics(haystack).toLowerCase();
  const sorted = [...bairros].sort((a, b) => b.length - a.length);
  for (const bairro of sorted) {
    const n = stripDiacritics(bairro).toLowerCase();
    if (normH.includes(n)) return bairro;
  }
  return '';
}

/**
 * Comparação: O parser recursivo tem overhead de chamadas e regex global.
 * O iterativo é O(n) em linhas, mais eficiente para textos longos.
 * Usamos o iterativo por ser mais adequado ao formato linha-a-linha.
 */
function parseIterative(text) {
  const acc = {};
  const lines = normalizePasteText(text).split('\n');
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];
    const keyMatch = line.match(FIELD_KEY_RE);

    if (keyMatch) {
      const [, key, value] = keyMatch;
      const normalizedKey = key.trim().toUpperCase().replace(/\s+/g, '_');
      let content = value.trim();

      while (i + 1 < lines.length && !lines[i + 1].match(FIELD_KEY_LINE_RE)) {
        i++;
        content += '\n' + lines[i];
      }

      acc[normalizedKey] = content;
    }
    i++;
  }

  return acc;
}

function parseWhatsAppOrder(text) {
  const raw = parseIterative(text);

  const parsePrice = (str) => {
    if (!str) return null;
    const cleaned = String(str).replace(/[^\d,]/g, '').replace(',', '.');
    return cleaned ? parseFloat(cleaned) : null;
  };

  const parseDate = (str) => {
    if (!str) return null;
    const m = str.match(/(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?/);
    if (!m) return null;
    const [, day, month, year] = m;
    const y = year ? (year.length === 2 ? 2000 + parseInt(year, 10) : parseInt(year, 10)) : new Date().getFullYear();
    const d = new Date(y, parseInt(month, 10) - 1, parseInt(day, 10));
    return isNaN(d.getTime()) ? null : d;
  };

  const mapPeriodo = (str) => {
    if (!str) return null;
    const s = (str || '').toLowerCase();
    if (s.includes('manhã') || s.includes('manha')) return 'Manhã 9h às 12h';
    if (s.includes('tarde')) return 'Tarde 12h às 18h';
    if (s.includes('noite')) return 'Noite 18h às 21h';
    return null;
  };

  const parseAddress = (str) => {
    if (!str) return { street: '', number: '', neighborhood: '', complement: '' };
    let rest = str.trim();

    let complement = '';
    let neighborhood = '';
    const pipeMatch = rest.match(/\s+\|\s+(.+)$/);
    if (pipeMatch) {
      const afterPipe = pipeMatch[1].trim();
      const doubleSpaceIdx = afterPipe.indexOf('  ');
      if (doubleSpaceIdx > 0) {
        complement = afterPipe.slice(0, doubleSpaceIdx).trim();
        neighborhood = afterPipe.slice(doubleSpaceIdx + 2).trim();
      } else {
        complement = afterPipe;
      }
      rest = rest.replace(/\s+\|\s+.+$/, '').trim();
    }

    const dashMatch = rest.match(/\s+-\s+(.+)$/);
    if (dashMatch && !complement) {
      complement = dashMatch[1].trim();
      rest = rest.replace(/\s+-\s+.+$/, '').trim();
    } else if (dashMatch && complement) {
      rest = rest.replace(/\s+-\s+.+$/, '').trim();
    }

    const numCommaNb = rest.match(/^(.+?)\s+(\d+),\s*(.+)$/);
    if (numCommaNb) {
      const [, streetPart, number, nb] = numCommaNb;
      return { street: streetPart.trim(), number, neighborhood: nb.trim(), complement };
    }

    const commaNumWithNb = rest.match(/^(.+?),\s*([\d.,]+)\s+(.+)$/);
    const commaNumOnly = rest.match(/^(.+?),\s*([\d.,]+)\s*$/);
    const commaNumMatch = commaNumWithNb || commaNumOnly;
    if (commaNumMatch) {
      const [, streetPart, number] = commaNumMatch;
      const nb = commaNumWithNb ? commaNumWithNb[3].trim() : neighborhood;
      return { street: streetPart.trim(), number, neighborhood: nb, complement };
    }

    const withNeighborhood = rest.match(/^(.+?)\s+(\d+)\s+(.+)$/);
    if (withNeighborhood && !neighborhood) {
      const [, street, number, nb] = withNeighborhood;
      return { street: street.trim(), number, neighborhood: nb.trim(), complement };
    }
    if (withNeighborhood && neighborhood) {
      const [, street, number] = withNeighborhood;
      return { street: street.trim(), number, neighborhood, complement };
    }

    const numberOnly = rest.match(/^(.+?)\s+(\d+)\s*$/);
    if (numberOnly) {
      const [, street, number] = numberOnly;
      return { street: street.trim(), number, neighborhood, complement };
    }

    return { street: rest, number: '', neighborhood, complement };
  };

  const parseContato = (str) => {
    if (!str) return { phone: '', name: '' };

    const phoneMatch = str.match(/([\d\s\-()]+)/);
    const phone = phoneMatch
        ? phoneMatch[1].replace(/\s/g, ' ').trim()
        : '';

    let namePart = str
        .replace(/[\d\s\-()]+/, '')
        .replace(/^\s*-\s*/, '')
        .trim();

    namePart = namePart.replace(/^\+/, '').trim();

    return { phone, name: namePart || '' };
  };

  const parseProduto = (str) => {
    if (!str) return { name: '', price: null };
    const priceMatch = str.match(/(\d{1,3}(?:[.,]\d{2})?)\s*$/);
    const price = priceMatch ? parsePrice(priceMatch[1]) : null;
    const name = priceMatch ? str.replace(/\s*\d{1,3}(?:[.,]\d{2})?\s*$/, '').trim() : str.trim();
    return { name, price };
  };

  const parseProdutos = (str) => {
    if (!str) return [];
    return str.split(/\n/)
      .map(line => line.trim())
      .filter(Boolean)
      .map(line => parseProduto(line))
      .filter(p => p.name);
  };

  const contato = parseContato(raw.CONTATO);
  const produtos = parseProdutos(raw.PRODUTO);
  let enderecoRaw = getRawField(raw, 'ENDEREÇO', 'ENDERECO');
  let inlineBairro = '';
  const inlineBairroMatch = enderecoRaw.match(/\sBAIRRO\s*:\s*(.+?)\s*$/i);
  if (inlineBairroMatch) {
    inlineBairro = inlineBairroMatch[1].trim();
    enderecoRaw = enderecoRaw.replace(/\sBAIRRO\s*:.+$/i, '').trim();
  }
  const endereco = parseAddress(enderecoRaw);
  const rawBairro = (getRawField(raw, 'BAIRRO') || inlineBairro).trim();
  const deliveryNeighbor = matchBairroRjFromEndereco(enderecoRaw, endereco.neighborhood, rawBairro);

  const clientName = (raw.CLIENTE || raw.NOME || contato.name || '').trim();
  const clientEmail = (raw.EMAIL || '').trim();
  const clientCpf = (raw.CPF || '').trim();
  const clientPhone = (raw.CONTATO ? contato.phone || raw.CONTATO.trim() : contato.phone) || '';

  return {
    data: raw.DATA,
    deliveryDate: parseDate(raw.DATA),
    periodo: raw.PERIODO,
    deliveryPeriod: mapPeriodo(raw.PERIODO),
    contato: raw.CONTATO,
    clientPhone,
    clientName,
    clientEmail,
    clientCpf,
    produto: raw.PRODUTO,
    products: produtos,
    envio: raw.ENVIO,
    deliveryValue: parsePrice(raw.ENVIO),
    total: parsePrice(raw.TOTAL),
    endereco: enderecoRaw,
    deliveryStreet: endereco.street,
    deliveryNumber: endereco.number,
    deliveryNeighbor,
    deliveryComplement: endereco.complement,
    quemEnvia: getRawField(raw, 'QUEM_ENVIA').trim(),
    quemRecebe: getRawField(raw, 'QUEM_RECEBE').trim(),
    observation: (raw.OBS || '').trim(),
    mensagem: (() => {
      const m = (raw.MENSAGEM || '').trim();
      return /^sem\s+mensagem$/i.test(m) ? '' : m;
    })()
  };
}

export function validateParsedOrder(parsed) {
  const missing = [];

  if (!parsed.products?.length) missing.push('PRODUTO');
  if (!parsed.deliveryStreet) missing.push('ENDEREÇO');
  if (!parsed.deliveryDate) missing.push('DATA (formato DD/MM ou DD/MM/AAAA)');
  if (!parsed.deliveryPeriod) missing.push('PERIODO (Manhã, Tarde ou Noite)');
  if (parsed.deliveryValue == null) missing.push('ENVIO (valor da entrega)');
  if (!parsed.quemEnvia) missing.push('QUEM ENVIA');
  if (!parsed.quemRecebe) missing.push('QUEM RECEBE');

  return { valid: missing.length === 0, missing };
}

export default parseWhatsAppOrder;
